// Focus mode: the app narrowed to one promise — fair, visible money between
// two people who share a home. It hides (never deletes) everything outside
// that: the assistant chat, grocery prices + the meal planner, Insights and
// investments. Turned on per build with VITE_FOCUS_MODE=true; unset gives the
// full app back, data untouched — the backend doesn't know the mode exists.
//
// Bank sync is deliberately not on the list: with billing off it is already
// hidden from everyone but hand-granted tiers, and those accounts depend on it.

import type { TierFeatures } from "../types/subscription"

export const isFocusMode = import.meta.env.VITE_FOCUS_MODE === "true"

const HIDDEN_TABS = new Set(["assistant", "insights", "grocery"])

// Global-search quick actions that lead into a hidden surface.
const HIDDEN_ACTIONS = new Set(["ask_assistant", "add_investment", "refresh_ai"])

export function isTabHidden(tabId: string, focus = isFocusMode): boolean {
  return focus && HIDDEN_TABS.has(tabId)
}

export function isActionHidden(actionId: string, focus = isFocusMode): boolean {
  return focus && HIDDEN_ACTIONS.has(actionId)
}

// The phone bottom bar. Focus mode trades Insights + Assistant for Household,
// which is where the arrangement and the housing contribution live.
export function bottomNavTabIds(focus = isFocusMode): string[] {
  return focus
    ? ["dashboard", "transactions", "budgets", "household"]
    : ["dashboard", "transactions", "budgets", "insights", "assistant"]
}

// AI stays where it shortens the core loop — plain-language quick-add, receipt
// scanning, AI budget setup, the home briefing. Only the standalone chat goes,
// along with investments; the surfaces that gate on these hide themselves.
export function applyFocusMode(features: TierFeatures, focus = isFocusMode): TierFeatures {
  if (!focus) return features
  return { ...features, aiAssistant: false, investments: false }
}
